"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
require("./NoPatientsNotification.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title,
  Paragraph = _typography.default.Paragraph;
var NoPatientsNotification = function NoPatientsNotification(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? 'No patients yet' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Once you are matched with a new patient, we will notify you and the card will appear on your list.' : _props$description;
  return /*#__PURE__*/_react.default.createElement(_card.default, {
    bordered: false,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "38",
    height: "50",
    viewBox: "0 0 38 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#3D5868",
    fillRule: "nonzero",
    d: "M19 0c2.455 0 4.566 1.347 5.495 3.277H28c.552 0 1 .41 1 .914V6h8a1 1 0 0 1 1 1v42a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8V4.19c0-.504.448-.913 1-.913h3.505C14.435 1.347 16.545 0 19 0zm10 9.587a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V8.399L2.4 8.4v39.2h33.2V8.4L29 8.399v1.188zM22.2 18a.8.8 0 0 1 .8.8V24h5.2a.8.8 0 0 1 .8.8v6.4a.8.8 0 0 1-.8.8H23v5.2a.8.8 0 0 1-.8.8h-6.4a.8.8 0 0 1-.8-.8V32H9.8a.8.8 0 0 1-.8-.8v-6.4a.8.8 0 0 1 .8-.8H15v-5.2a.8.8 0 0 1 .8-.8h6.4zm-1.6 2.4h-3.2v6h-6v3.2h6v6h3.2v-6h6v-3.2h-6v-6zM19 2.193c-1.442 0-2.727.781-3.298 1.967l-.358.743a1 1 0 0 1-.9.566H11.4v2.925h15.2V5.47h-3.043a1 1 0 0 1-.901-.567l-.358-.743C21.727 2.974 20.442 2.193 19 2.193z"
  })), /*#__PURE__*/_react.default.createElement(Title, {
    level: 2
  }, title), /*#__PURE__*/_react.default.createElement(Paragraph, {
    strong: true
  }, description));
};
var _default = NoPatientsNotification;
exports.default = _default;